<template>
  <div class="potential-well-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>E_n = n²h² / (8mL²)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Well Walls -->
          <rect x="100" y="40" width="10" height="160" fill="#333" />
          <rect x="290" y="40" width="10" height="160" fill="#333" />
          <text x="50" y="120" fill="#ff4757" font-size="10" transform="rotate(-90, 50, 120)">V = ∞</text>
          <text x="350" y="120" fill="#ff4757" font-size="10" transform="rotate(-90, 350, 120)">V = ∞</text>

          <!-- Probability Density Function (Wavefunction^2) -->
          <path :d="wavePath" fill="none" stroke="#00d2ff" stroke-width="2">
             <animate attributeName="opacity" values="0.4;0.8;0.4" dur="2s" repeatCount="indefinite" />
          </path>
          
          <!-- Energy Level Indicator -->
          <line x1="110" :y1="190 - n*20" x2="290" :y2="190 - n*20" stroke="rgba(255, 255, 255, 0.2)" stroke-dasharray="2" />
          <text x="305" :y="190 - n*20 + 3" fill="#888" font-size="8">E_{{ n }}</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>能级量子数 n: {{ n }}</label>
              <div class="value">能量 ∝ {{ n*n }}</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>选择量子能级 n</label>
             <el-radio-group v-model="n" size="mini">
                <el-radio-button :label="1">n=1</el-radio-button>
                <el-radio-button :label="2">n=2</el-radio-button>
                <el-radio-button :label="3">n=3</el-radio-button>
             </el-radio-group>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>在微观世界中，被束缚在势阱中的粒子其能量不能任意取值，而是**量子化**的。波函数描述了粒子在空间各处出现的**几率密度**。n=1 是基态，其几率中心在势阱中央；n 越大，波函数的节点越多，能量也越高。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PotentialWellViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      n: 1
    }
  },
  computed: {
    wavePath() {
      let d = "M 110 200 ";
      let width = 180;
      let amp = 50;
      for (let x = 0; x <= width; x += 2) {
        // psi(x) = sqrt(2/L) * sin(n pi x / L)
        // Probability = psi^2
        let val = Math.pow(Math.sin((this.n * Math.PI * x) / width), 2);
        let y = 200 - val * amp - (this.n * 20); // Scale and offset by energy
        d += `L ${110 + x} ${y} `;
      }
      d += `L 290 200`;
      return d;
    }
  }
}
</script>

<style scoped lang="scss">
.potential-well-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 10px; } 
}
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
